import React, { useState, useEffect } from "react";
import NewCVEsStatisticsTable from "./NewCVEsStatisticsTable";
import http from "../services/httpService.js";
const { SERVER_BASE_URL } = require("../env");

function NewCVEsPage() {
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await http.get(`${SERVER_BASE_URL}/my-cpes`, {
          headers: { "x-auth-token": localStorage.getItem("token") },
        });

        let programsClone = response.data;
        programsClone = programsClone.filter((p) => p.newCVEs.length !== 0);
        setPrograms(programsClone);
      } catch (e) {
        if (e.response && e.response.status == 401) {
          window.location = "/";
        }
      }
    }
    fetchData();
  }, []);

  return (
    <div className="centeral-container">
      <div className="page-top-title farsi-bold">
        آسیب‌پذیری‌های 90 روز گذشته‌ی هر برنامه‌
      </div>
      <NewCVEsStatisticsTable items={programs}></NewCVEsStatisticsTable>
    </div>
  );
}

export default NewCVEsPage;
